<p-toast></p-toast>

<div class="auth-container-login">
  <!-- Left Side - Background Image -->
  <div class="auth-left">
    <img src="assets/layout/images/bgimage.png" alt="Background" class="background-image">
    <div class="background-overlay">
      <div class="welcome-content">
        <h1>Secure Access</h1>
        <p>Reset your password safely</p>
      </div>
    </div>
  </div>

  <!-- Right Side - Forgot Password Form -->
  <div class="auth-right">
    <div class="form-container">
      <div class="logo-section">
        <div class="logo-row">
          <img src="assets/layout/images/wow-care-logo-new.png" alt="WowCare Logo" class="logo">
          <span class="brand-text">WowCare</span>
        </div>
        <h3>Forgot Password</h3>
      </div>

      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <div class="input-wrapper">
            <i class="pi pi-envelope input-icon"></i>
            <input
              pInputText
              id="email"
              formControlName="email"
              placeholder="Enter your email address"
              class="form-input"
            />
          </div>
          <small *ngIf="forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched" class="error-text">
            Please enter a valid email address
          </small>
        </div>

        <div class="form-actions">
          <button
            pButton
            type="submit"
            label="Send Reset Link"
            [loading]="loading"
            class="auth-button"
            [disabled]="forgotForm.invalid"
          ></button>
        </div>

        <div class="auth-links">
          <a routerLink="/login" class="back-link">← Back to Login</a>
        </div>
      </form>

      <div class="app-buttons" style="display: flex; justify-content: center; align-items: center; gap: 20px; margin-top: 30px;">
        <a href="https://apps.apple.com/us/app/wowcare/id6630378434" target="_blank" rel="noopener noreferrer">
          <img src="assets/layout/images/appstoreplay.png" alt="App Store" class="app-button" style="height: 3rem; cursor: pointer; transition: transform 0.2s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.wiseowlworld.schoolerpwowapp" target="_blank" rel="noopener noreferrer">
          <img src="assets/layout/images/googleplay.jpg" alt="Google Play" class="app-button" style="height: 3rem; cursor: pointer; transition: transform 0.2s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
        </a>
      </div>
    </div>
  </div>
</div>